const SIVAC = {
    C006TiposRubros: 'SIVAC/Catalogos/GetTiposRubros',
    C008TiposEstatusFirma: 'SIVAC/Catalogos/GetTiposEstatusFirma',
    C009TiposTemporalidad: 'SIVAC/Catalogos/GetTiposTemporalidad',
    C010TiposFirmoEnTiempo: 'SIVAC/Catalogos/GetTiposFirmoEnTiempo',
    C013TiposEstatusProcesado: 'SIVAC/Catalogos/GetTiposEstatusProcesado',
    C016TiposMovimientos: 'SIVAC/Catalogos/GetTiposMovimientos',
    C019TiposBanco: 'SIVAC/Catalogos/GetTiposBanco',
    C020TiposEstatusDevolucion: 'SIVAC/Catalogos/GetTiposEstatusDevolucion',
    C004TiposAreaDeposito: 'SIVAC/Catalogos/GetTiposArea'
   
    
  };
    
  export default SIVAC;


//////////////////
// WEBPACK FOOTER
// ./static/js/api/SIVAC/catalogos/catalogos.js
// module id = null
// module chunks = 